export const storeTypes = `
  data {
  id
    attributes {
      title
    }
  }
`;